<template>
  <v-layout>
    <v-col>
      <v-dialog
        v-model="showConfirm"
        :max-width="options.width"
        :style="{ zIndex: options.zIndex }"
        @keydown.esc="cancel"
      >
        <v-card>
          <v-toolbar
            dark
            :color="options.color"
            dense
            flat
          >
            <v-toolbar-title class="white--text">
              {{ title }}
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text v-show="!!message">
            <div class="message">
              {{ message }}
            </div>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer />
            <v-btn
              color="primary darken-1"
              text
              @click.native="agree"
            >
              Yes
            </v-btn>
            <v-btn
              color="grey"
              text
              @click.native="cancel"
            >
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-layout>
</template>

<style scoped>
.message {
  padding-top: 5%;
}
</style>

<script>
import { mapActions } from "vuex";
export default {
  props: {
    closeForm: {
      type: Function,
      default: () => 1
    }
  },
  data: () => ({
    showConfirm: false,
    message: "Are you sure you want to remove this event from the calendar?",
    title: "Remove Event",
    options: {
      color: "primary",
      width: 290,
      zIndex: 200
    }
  }),
  computed: {},
  methods: {
    ...mapActions("calendar", ["deleteEvent"]),
    showConfirmation(event) {
      this.showConfirm = true;

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      }).then(resolve => {
        if (resolve) {
          this.deleteEvent(event.pk);
          this.closeForm(); // calls cancel(), which is passed down as prop from parent component AddEventForm
        }
      });
    },
    agree() {
      this.resolve(true);
      this.showConfirm = false;
    },
    cancel() {
      this.resolve(false);
      this.showConfirm = false;
    }
  }
};
</script>
